export default function DeleteIcon({
  width = 12,
  height = 15,
  color = "#FC3400",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3687 6C10.6448 6 10.8687 6.22386 10.8687 6.5C10.8687 6.53856 10.8642 6.57699 10.8554 6.61452L9.3628 12.9581C9.1502 13.8615 8.3441 14.5 7.41597 14.5H4.58403C3.65593 14.5 2.84977 13.8615 2.6372 12.9581L1.14459 6.61452C1.08135 6.34572 1.24798 6.07654 1.51678 6.01329C1.55431 6.00446 1.59274 6 1.6313 6H10.3687ZM6.5 0.5C7.88071 0.5 9 1.61929 9 3H11C11.5523 3 12 3.44772 12 4V4.5C12 4.77614 11.7761 5 11.5 5H0.5C0.22386 5 0 4.77614 0 4.5V4C0 3.44772 0.44772 3 1 3H3C3 1.61929 4.11929 0.5 5.5 0.5H6.5ZM6.5 2H5.5C4.94772 2 4.5 2.44772 4.5 3H7.5C7.5 2.44772 7.05228 2 6.5 2Z"
        fill={color}
      />
    </svg>
  );
}
